import { StarIcon } from "@heroicons/react/20/solid";
import { useState } from "react";

// The stars are controls, not decoration: each one is a button, so it takes
// keyboard focus and reads out its value, and hovering previews the rating
// before committing to it. `labels` names the current choice in words — five
// identical stars tell you how many you picked, not what you said.
export default function HRStarsInput({ value = 0, onChange, labels = [] }) {

    const [hovered, setHovered] = useState(0);
    const shown = hovered || value;

    return (
        <div className="flex flex-col items-center gap-1">
            <div className="flex flex-row" onMouseLeave={() => setHovered(0)}>
                {[1, 2, 3, 4, 5].map((star) => (
                    <button
                        key={star}
                        type="button"
                        aria-label={labels[star - 1] || String(star)}
                        aria-pressed={value === star}
                        onMouseEnter={() => setHovered(star)}
                        onFocus={() => setHovered(star)}
                        onBlur={() => setHovered(0)}
                        onClick={() => onChange(star)}
                        className="rounded-lg p-1 transition-transform hover:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
                    >
                        <StarIcon
                            className={`h-9 w-9 transition-colors ${star <= shown ? "fill-[#F6BA00]" : "fill-neutral-400"}`}
                        />
                    </button>
                ))}
            </div>
            {/* Fixed height so naming the choice never nudges the form. */}
            <span className={`font-text h-4 ${shown ? "text-neutral-1100" : "text-neutral-400"}`}>
                {shown ? labels[shown - 1] : ""}
            </span>
        </div>
    );
}
